import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";

// Material UI Components
import { Box, Typography } from "@mui/material";

// Material UI Icons
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // GSAP animation for "B" flipping and appearing in stages (25%, 50%, 75%, 100%)
    const tl = gsap.timeline();
    
    tl.fromTo(
      ".page-not-found-box",
      {
        y: -100, // Start below its normal position
      },
      {
        y: 0, // Rise to the normal position
        duration: 1.5,
        ease: "bounce.out",
        //
      }
    );
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#023047",
        color: "white",
        textAlign: "center",
        p: 2,
      }}
    >
      <Typography
        className="page-not-found-box"
        fontWeight="bold"
        sx={{
          color: "#023047",
          bgcolor: "rgba(255, 255, 255, 1)",
          borderRadius: 4,
          px: 2,
          width: "fit-content",
          fontSize: "6rem",
          my: 4,
        }}
      >
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Oops! The page you're looking for doesn't exist.
      </Typography>
      <button
        onClick={() => navigate("/")}
        style={{ mt: 2, borderColor: "white", color: "white" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "black")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
      >
        <KeyboardBackspaceRoundedIcon />
        <Typography fontWeight="bold" sx={{ mx: 2 }}>
          Go Back Home
        </Typography>
      </button>
    </Box>
  );
};

export default PageNotFound;
